<template>
    <div id="content">
        <div class="inner">
            <h1 v-translate>Crony</h1>
        </div>

        <div class="inner_white">
          <div class="table_overflow">
            <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                <thead>
                <tr>
                    <th class="no_padding drag_drop"></th>
                    <sorting-table-title
                            v-for="title in sortingTableTitles"
                            :key="title.id"
                            :column="title.column"
                            :sort="getActiveSort(title.column)"
                            @changeSorting="changeSorting"
                    >{{ title.name }}
                    </sorting-table-title>
                    <th class="no_padding"></th>
                    <th class="no_padding edit"></th>
                </tr>
                </thead>
                <tbody>
                <cron-row
                        v-for="cron in entities"
                        :cron="cron"
                        :key="cron.id"
                        @runCron="runCron"
                        @unlockCron="unlockCron"
                        @updateCron="updateEntity"
                        @deleteCron="deleteEntity"
                ></cron-row>
                </tbody>
            </table>
          </div>
        </div>
    </div>
</template>

<script>
    import CronRow from "@/components/views/crons/CronRow"
	import listActions from "@/components/mixins/list-actions"

	export default {
		name: "CronList",
        components: {CronRow},
		mixins: [listActions],
		data() {
			return {
				moduleName: 'crons',
                sortingTableTitles: [
					{id: 1, name: this.$gettext('Název')},
					{id: 2, name: this.$gettext('Popis')},
					{id: 3, name: this.$gettext('Celkový počet běhů')},
					{id: 4, name: this.$gettext('Počet běhů za posledních 24h')},
					{id: 5, name: this.$gettext('Poslední status')},
					{id: 6, name: this.$gettext('Poslední výsledek')},
                ],
			}
		},
		created(CronService) {
			this.entityService = CronService
			this.createdInit()
		},
		methods: {
			runCron(cronId) {
				this.setLoadingMessage()
				this.entityService.runCron(cronId)
					.then(() => {
						this.getEntities()
					})
					.catch(error => {
            if(error.error_message == "Cron run was skipped. This is not the primary server."){
                this.setErrorMessage(this.$gettext('Běh cronu byl přeskočen. Toto není primární server.'));
            }else {
              console.error(error)
              this.setErrorMessage(this.$gettext('Nastala chyba. Podívejte se do console logu.'))
            }
					})
			},
			unlockCron(cronId) {
				this.setLoadingMessage()
				this.entityService.unlockCron(cronId)
					.then(() => {
						this.getEntities()
					})
					.catch(error => {
						console.error(error)
						this.setErrorMessage(this.$gettext('Nastala chyba. Podívejte se do console logu.'))
					})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/crons/CronList.vue